import React, { useEffect, useState } from "react";
import SiteHeader from "./SiteHeader";
import ExperienceList from "./ExperienceList";
import ResearchList from "./ResearchList";
import FeaturedMarquee from "./FeaturedMarquee";
import ProjectList from "./ProjectList";
import SkillsStrip from "./SkillsStrip";
import {
  apps,
  certifications,
  education,
  experiences,
  experiments,
  featured,
  research,
} from "../../data/portfolio";

const storageKey = "portfolio-theme";

const Portfolio = () => {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const saved = window.localStorage.getItem(storageKey);
    if (saved === "dark") return true;
    if (saved === "light") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
    window.localStorage.setItem(storageKey, dark ? "dark" : "light");
  }, [dark]);

  return (
    <div className="min-h-screen bg-[#fafafa] text-zinc-950 antialiased dark:bg-zinc-950 dark:text-zinc-50">
      <div className="relative mx-auto max-w-[860px] px-6 pb-24 pt-16">
        <SiteHeader dark={dark} onToggleTheme={() => setDark((v) => !v)} />
        <main className="relative z-[2] mt-6 space-y-16 md:mt-8">
          <ExperienceList title="Experiences" items={experiences} />
          <FeaturedMarquee items={featured} />
          <ProjectList title="Apps" items={apps} />
          <ProjectList title="Open source & experiments" items={experiments} />
          <ResearchList items={research} />
          <ProjectList title="Certifications" items={certifications} />
          <ExperienceList title="Education" items={education} />
          <SkillsStrip />
        </main>
      </div>
    </div>
  );
};

export default Portfolio;
